<template lang="pug">
.c-historial
    .buttons-wrapper
        .button-wrapper
            button(@click="printAsPdf") Descargar Cotización
                img(src="../assets/images/flecha-hacia-abajo.svg")
        .button-wrapper
            button(@click="downloadDocuments") Descargar Adjuntos
                img(src="../assets/images/flecha-hacia-abajo.svg")
    h3.c-historial__title Historial
    .c-historial__list
        .c-historial__item(v-for="(item, index) in events")
            .c-historial__date
                span {{dateFormat(item.created)}}
            .c-historial__icon
                span.circle.circle--green(v-if="index === (events.length - 1)")
                span.circle.circle--grey(v-else)
            .c-historial__description(v-if="item.state == '2'")
                span {{item.status_name}} por BROKER
            .c-historial__description(v-else)
                span {{item.status_name}} en {{item.recipient_inbox_name}} 
</template>
<script>
import axios from 'axios';
import { getAccessToken } from '../utils/auth';
import SiteConfig from '../services/positiva'

export default {
    name: 'AppQuotationHistory',
    props: {
        events: Array,
        code: String,
        quotationId: String
    },
    data() {
        return {
            toastMessage: ""
        }
    },
    methods: {
        downloadDocuments() {
            const loader = this.$buefy.loading.open();
            this.toastMessage = "La descarga podría demorar unos minutos"
            this.showToast()
            const config = {
                headers: {
                    'Authorization': `Token ${getAccessToken()}`,
                    'content-type': 'application/json'
                }
            }
            axios.create(config).get(`${SiteConfig.BASE_URL}/quotation/${this.quotationId}/attachments`).then(result => {
                loader.close()
                window.atob(result.data)
                this.download(`cotización_${this.code}.zip`, result.data)
            }).catch((error) => {
                loader.close()
                this.toastMessage = error.response.data.detail
                this.showToast()
            })
        },
        showToast() {
            console.log("mostrar toast", this.toastMessage)
            this.$buefy.toast.open({
                duration: 3000,
                message: this.toastMessage,
                position: 'is-bottom',
                type: 'is-primary'
            })
        },
        download(filename, data) {
            var element = document.createElement('a');
            element.setAttribute('href', 'data:text/plain;base64,' + data);
            element.setAttribute('download', filename);

            element.style.display = 'none';
            document.body.appendChild(element);

            element.click();

            document.body.removeChild(element);
        },

        printAsPdf() {
            window.print()
        },

        dateFormat(time) {
            let date = new Date(time)
            return date.toLocaleString("en-GB", { hour12: true })
        },
    }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/variables.scss';
    .c-historial__date {
        width:80px;
    }
    .buttons-wrapper {
        display: flex;
        flex-direction: column;
    }
    button {
        display: flex;
        flex-direction: row-reverse;
        justify-content: center;
        align-items: center;
        border-style: solid;
        border-radius: 5px;
        border-width: 2px;
        height: 32px;
        width: 220px;
        margin-bottom: 10px;
        background-color: white;
        border-color: $green;
        color: $green;
    }
    img{
        height: 16px;
        width: 16px;
        margin-right: 5px;
    }
</style>
